module.exports = "/_next/static/images/first-login-image-af2a0130d0a594f066ebfe73389a4be7.svg";